import { mapState } from 'vuex';
export default {
  install(Vue, store){
    let app = new Vue({
      store,
      computed: {
        ...mapState({
          permissions: state => state.user.permissions
        })
      },
      methods: {
        can(permission) {
          return this.permissions.includes(permission);
        }
      }
    });
    Vue.prototype.$can = app.can;
  }
}
